import type { AxiosError } from "axios";

import { GeneralPageError } from "@/components/Errors/GeneralPageError";
import { OfferNotAvailableError } from "@/components/Errors/OfferNotAvailableError";
import type { OfferIsNotAvailableAnymoreOutputDto } from "@/types/codegen";
import { isOfferIsNotAvailableAnymoreError } from "@/utils/assertions";

interface FlightOfferErrorProps {
  error: Error | AxiosError<OfferIsNotAvailableAnymoreOutputDto>;
}

export const FlightOfferError = ({ error }: FlightOfferErrorProps) => {
  if (isOfferIsNotAvailableAnymoreError(error)) {
    return <OfferNotAvailableError variant="flight" />;
  }

  return (
    <GeneralPageError
      backOptions={{ to: "/", search: { category: "flights" } }}
    />
  );
};
